import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';

export const CategoryButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  gap: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  width: 100%;
  align-items: center;
  justify-content: center;

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    flex-direction: row;
    flex-wrap: nowrap;
    width: max-content;
    overflow-x: hidden;
    white-space: nowrap;
    justify-content: flex-start;
    overflow-y: hidden;
  }
`;

// ➊ width 0 → 100% 로 확장되는 키프레임
const expand = keyframes`
  from { width: 0; }
  to   { width: 100%; }
`;

export const CategoryButton = styled.div<{ selected: boolean }>`
  position: relative;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    padding: 16px 4px;
  }

  // ➋ 가상 요소로 밑줄 생성
  &::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    z-index: 10;
    height: 2px;
    background-color: #2a70f0;
    transform-origin: left;
    width: 0; /* 기본은 0 */
    ${({ selected }) =>
      selected &&
      css`
        animation: ${expand} 3s linear forwards;
      `}
  }
`;

export const LogoBox = styled.img`
  width: 120px;
  height: 50px;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    width: 90px;
    height: 38px;
  }

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    width: 100%; /* 가로 칸을 꽉 채움 */
    height: auto; /* 비율 유지하며 자동 조절 */
    aspect-ratio: 6 / 2.5; /* 60px × 25px 비율 유지 */
    object-fit: contain;
  }
`;

export const LogoWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(8, 120px); /* 고정 8컬럼 */
  row-gap: 12px; /* 세로 간격 */
  column-gap: 0; /* 가로 간격은 남는 폭으로 자동 */
  justify-content: space-between; /* 남는 가로폭을 7개 틈에 균등 배분 */

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    grid-template-columns: repeat(8, 90px);
    row-gap: 6px;
  }
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    grid-template-columns: repeat(5, 1fr); /* 5칸 균등 분할 */
    column-gap: 6px; /* 가로 간격 6px */
    row-gap: 4px; /* 세로 간격 4px */
    justify-content: space-between;
  }
`;
